export default __webpack_public_path__ + "static/media/marker.1883bdb7.svg";